export default "__VITE_ASSET__DSfUl3D$__"